import { LOCALIZATION_URL } from "@/lib/constants";

export const fallbackLng = "tr";
export const languages = [fallbackLng, "en"];
export const defaultNS = "site";
export const cookieName = "i18next";

export function getOptions(lng = fallbackLng, ns = defaultNS) {
  return {
    // debug: true,
    supportedLngs: languages,
    // preload: languages,
    fallbackLng,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns,
    backend: {
      loadPath: `${LOCALIZATION_URL}/locale?namespace={{ns}}&lng={{lng}}`,
      addPath: `${LOCALIZATION_URL}/locale?namespace={{ns}}&lng={{lng}}`,
    },
  };
}
